import React, { Component } from 'react'
import { Spinner } from 'react-bootstrap'
import ApprovalTable from './ApprovalTable'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import './style.css'
import { FaFilter } from 'react-icons/fa';
import Hexapi from '../../utility/HexAPI/Hexapi';
import Filters from '../../components/Filtermodal/Filters';
import Loader from '../../components/loader/Loader';



export default class TableMain extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedtileapprovalsInfo: {}, selectedTableTab: 'Pending',
            tableData: [], isApiHitComplete: false, isDataFound: false,
            selectedRequestName: 'recvd', isLastList: false, ListLength: 0,
            filterstr:-1,
            defaultdata:[],
            fileterdata:[],
            openmodal:false
        }
        this.getRecvList = this.getRecvList.bind(this)
        this.getSentList = this.getSentList.bind(this)
        this.getTable = this.getTable.bind(this)
        this.onChangeTab = this.onChangeTab.bind(this)
        this.onRequestChange = this.onRequestChange.bind(this)
        this.getRequestName = this.getRequestName.bind(this)
        this.clearfilters=this.clearfilters.bind(this)
        this.applyfilters=this.applyfilters.bind(this)
    }

    applyfilters(filterstr,updatedvalue){
        console.log(filterstr,"filterstr")
        if (updatedvalue && updatedvalue[0].values) {
           const updatedFilters = this.state.fileterdata.map(filter => {
              const filterName = filter.filtername; 
              if (updatedvalue[0].values.hasOwnProperty(filterName)) {
                return {
                  ...filter,
                  values: updatedvalue[0].values[filterName],
                  defval: updatedvalue[0].def[filterName]
                };
              }
      
              return filter;
            });
            
            this.setState({openmodal:false,
                ListLength:[],
                fileterdata:updatedFilters,
                filterstr:filterstr
                
            },()=>{ 
                
                if (this.state.selectedRequestName == "recvd") {
                    this.getRecvList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',filterstr)
            }
            if (this.state.selectedRequestName == "sent") {
                this.getSentList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',-1)
            }
                
            })
          } 
       
    }
clearfilters(){
    this.setState({openmodal:false,
        ListLength:[],
        filterstr:-1,
    },()=>{
        if (this.state.selectedRequestName == "recvd") {
            this.getRecvList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',-1)
        }
        if (this.state.selectedRequestName == "sent") {
            this.getSentList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',-1)
        }
    })
}
    getRecvList(userid, approvaltype, lastrecid,filterStr) {
        
        var approvalstage = ''
        if (this.state.selectedTableTab == "Pending") {
            approvalstage = "0"
        } else if (this.state.selectedTableTab == "Accepted") {
            approvalstage = "1"
        } else if (this.state.selectedTableTab == "Rejected") {
            approvalstage = '2'
        }
        let obj = {
            'query': `HRApp_Droid_Proc_User_Approvals_Received_GetListv2 @UserID='{0}',@ApprovalType='{1}',@ApprovalStage='{2}',@LastRecID='{3}',@Filter='{4}'`,
            'queryArr': [`${userid}`, `${approvaltype}`, `${approvalstage}`, `${lastrecid}`,`${filterStr}`]
        }
								
        if (lastrecid == -1) {
            this.setState({ isApiHitComplete: false,tableData:[] })
        }
        Hexapi(obj).then((resp) => {
            console.log(resp,"responseapproval")

            if(resp.filters && filterStr == -1){
                this.setState({fileterdata:resp.filters})
            }

            if (resp.approvallist != undefined && resp.approvallist.length > 0) {
                console.log("called")
                if (resp.approvallist.length < this.state.ListLength) {
                    console.log("calledtrue")
                    this.setState({ isLastList: true })
                } else if(resp.approvallist.length <20){
                    this.setState({ isLastList: true, ListLength: resp.approvallist.length })
                }
                    else {
                    console.log("calledfalse")
                    this.setState({ isLastList: false, ListLength: resp.approvallist.length })
                }
                if (lastrecid != '-1') {
                    this.setState({
                        tableData: this.state.tableData.concat(resp.approvallist),
                        isDataFound: true
                    })
                } else {
                    this.setState({
                        tableData: resp.approvallist,
                        isDataFound: true
                    })
                }
            } else {
                if (resp[''].length < this.state.ListLength) {
                    this.setState({ isLastList: true, isDataFound: true })
                } else {
                    this.setState({ isLastList: false, isDataFound: false })
                }
            }
        }).then(() => this.setState({ isApiHitComplete: true })).catch(err => console.error(err))
    }
    getSentList(userid, approvaltype, lastrecid,filterstr) {
        var approvalstage = ''
        if (this.state.selectedTableTab == "Pending") {
            approvalstage = "0"
        } else if (this.state.selectedTableTab == "Accepted") {
            approvalstage = "1"
        } else if (this.state.selectedTableTab == "Rejected") {
            approvalstage = '2'
        }
        let obj = {
            'query': `HRApp_Droid_Proc_User_Approvals_Sent_GetList @UserID='{0}',@ApprovalType='{1}',@ApprovalStage='{2}',@LastRecID='{3}'`,
            'queryArr': [`${userid}`, `${approvaltype}`, `${approvalstage}`, `${lastrecid}`]
        }
        if (lastrecid == -1) {
            this.setState({ isApiHitComplete: false,tableData:[] })
        }
        Hexapi(obj).then((resp) => {
            console.log(resp,"sentdata")
            if(resp.filters && filterstr === -1){
                this.setState({fileterdata:resp.filters})
            }
            if (resp.approvallist != undefined && resp.approvallist.length > 0) {
                if (resp.approvallist.length < this.state.ListLength) {
                    this.setState({ isLastList: true })
                }  else if(resp.approvallist.length <20){
                    this.setState({ isLastList: true, ListLength: resp.approvallist.length })
                }else {
                    this.setState({ isLastList: false, ListLength: resp.approvallist.length })
                }
                if (lastrecid != '-1') {
                    this.setState({
                        tableData: this.state.tableData.concat(resp.approvallist),
                        isDataFound: true
                    })
                } else {
                    this.setState({
                        tableData: resp.approvallist,
                        isDataFound: true
                    })
                }
            } else {
                if (resp[''].length < this.state.ListLength) {
                    this.setState({ isLastList: true, isDataFound: true })
                } else {
                    this.setState({ isLastList: false, isDataFound: false })
                }
            }
        }).then(() => this.setState({ isApiHitComplete: true })).catch(err => console.error(err))
    }
    getTable(type) {
        return (
            this.state.isApiHitComplete ?
                this.state.isDataFound ?
                    <ApprovalTable
                        tableData={this.state.tableData}
                        getPhotoUrl={this.props.getPhotoUrl}
                        selectedType={this.state.selectedTableTab}
                        approvaltype={this.props.selectedtileapprovalsInfo.approvaltype}
                        RequestCategory={this.state.selectedRequestName}
                        userid={this.props.userid}
                        LoadMore={(recid) => this.state.selectedRequestName == "recvd" ? this.getRecvList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, recid,this.state.filterstr) : this.getSentList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, recid)}
                        isLastList={this.state.isLastList}
                    />
                    :
                    <div className="TemporaryTableDiv">
                        <h5 style={{ color: 'orange' }}>No Records!</h5>
                    </div>
                :
                <div className="TemporaryTableDiv">
                     <Loader/>
                
                </div>
        )
    }

    componentDidMount() {
        // console.log(this.props.selectedtileapprovalsInfo)
        console.log( window.innerHeight ,"console")
        this.setState({
            selectedtileapprovalsInfo: this.props.selectedtileapprovalsInfo
        })
        let approvaltype = this.props.selectedtileapprovalsInfo.approvaltype,
            lastrecid = '-1'

        this.getRecvList(this.props.userid, approvaltype, lastrecid,-1)
    }

    onChangeTab(e, selectedTab) {
        console.log( window.innerHeight ,"console")
        this.setState({
            selectedTableTab: selectedTab,
            tableData: [],
            fileterdata:[],
            filterstr:-1
        }, () => {
            if (this.state.selectedRequestName == "recvd") {
                this.getRecvList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',-1)
            }
            if (this.state.selectedRequestName == "sent") {
                this.getSentList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',-1)
            }
        })
    }
    onRequestChange(e) {
        this.setState({ selectedRequestName: e.target.value, tableData: [] ,fileterdata:[]})
        if (e.target.value == "recvd") {
            this.getRecvList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1',-1)
        }
        if (e.target.value == "sent") {
            this.getSentList(this.props.userid, this.props.selectedtileapprovalsInfo.approvaltype, '-1')
        }
    }
    getRequestName(approvaltype, requestType) {
        let name = '',str=''
        if (approvaltype == '1') {
            name = "Overtime"
        } else if (approvaltype == '2') {
            name = 'Subordinate'
        } else if (approvaltype == '3') {
            name = "TagID"
        } else if (approvaltype == '4') {
            name = 'Leave'
        }else if (approvaltype == '5') {
            name = 'Gate Pass'
        }else if (approvaltype == '6') {
            name = 'Expense'
        }else if (approvaltype == '7') {
            name = 'Field Pass'
        }
        if (requestType == "recvd") {
            str = `Rcvd ${name} Requests`
 
        } else if (requestType == "sent") {
            str = `Sent ${name} Requests`
        }
        return str
    }
    render() {
        return (
            <>
                <div style={{display:"flex"}}>
                    <div className='col-6' style={{display:"flex"}}>
                    <div style={{minWidth:"60px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <IconButton onClick={() => this.props.goBack()}>
                            <ArrowBackIcon />
                        </IconButton>
                    </div>
                    <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                        <Select
                            labelId="demo-select-small"
                            id="demo-select-small"
                            value={this.state.selectedRequestName}
                            onChange={(e) => this.onRequestChange(e)}
                        >
                            <MenuItem value={"recvd"}>{this.getRequestName(this.props.selectedtileapprovalsInfo?.approvaltype, 'recvd')}</MenuItem>
                            <MenuItem value={"sent"}>{this.getRequestName(this.props.selectedtileapprovalsInfo?.approvaltype, 'sent')}</MenuItem>
                            
                        </Select>
                    </FormControl>
                    <TabContext value={this.state.selectedTableTab} >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={(e, value) => this.onChangeTab(e, value)} aria-label="lab API tabs example">
                                    <Tab label="Pending" value="Pending" />
                                    <Tab label="Accepted" value="Accepted" />
                                    <Tab label="Rejected" value="Rejected" />
                                </TabList>
                            </Box>
                    </TabContext>
                    </div>
                    {this.state.fileterdata.length>0 && <div className='col-6' style={{textAlign:"end",alignContent:"center" }}>
                        
                        <FaFilter style={{fontSize:"20px" ,color:"gray", cursor:"pointer",marginRight:"10px"}} onClick={()=>this.setState({openmodal:true})} />
                        </div>}
                    
                </div>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={this.state.selectedTableTab} >
                        
                        <TabPanel value="Pending">
                            {this.getTable("Pending")}
                        </TabPanel>
                        <TabPanel value="Accepted">
                            {this.getTable("Accepted")}
                        </TabPanel>
                        <TabPanel value="Rejected">
                            {this.getTable("Rejected")}
                        </TabPanel>
                    </TabContext>
                </Box>

                {this.state.openmodal && <Filters
                show={this.state.openmodal}
                filters={this.state.fileterdata}
                clearFilters={()=>this.clearfilters()}
                applyFilters={(filterstr,updatedvalue)=>this.applyfilters(filterstr,updatedvalue)}
                hide={()=>this.setState({openmodal:false})}/>}
            </>
            
        )
    }
}
